import { render, staticRenderFns } from "./check-index.vue?vue&type=template&id=3247c391&scoped=true&"
import script from "./check-index.vue?vue&type=script&lang=js&"
export * from "./check-index.vue?vue&type=script&lang=js&"
import style0 from "./check-index.vue?vue&type=style&index=0&id=3247c391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247c391",
  null
  
)

export default component.exports